import React, { Component } from "react";

export class DetailPl extends Component {
    render() {
        return <div id="wrappDetailPl" className="detail-process">

            <div className="wrapp-interna-process-banner">
                <img src={require('../../images/pl.jpg')} />
            </div>

            <h2 class="text-center d-inline-block margin-top-40">Programa de liderazgo</h2>
            <div className="text-center d-inline-block">
                <span>1er y 2do fin de semana</span><span>|</span><span>$1.650.000</span>
            </div>
            <div className="text-center d-inline-block">
                <span>3er fin de semana</span><span>|</span><span>$495.000</span>
            </div>
            <p>
                ¿ESTAS LISTO PARA DAR Y RECIBIR CON EL CORAZÓN?
            </p>

            <p>
                El programa de liderazgo es un entrenamiento que sirve como herramienta para convertir tu visión personal en realidad, partiendo de los principios adquiridos durante el Básico y el Avanzado, de transformación, logro y excelencia.
            </p>

            <p>
                El programa de liderazgo es una oportunidad para trabajar día a día en nuestros logros personales.
            </p>

            <b>RESULTADOS</b>
            <p>
                El Programa de Liderazgo (PL) esta diseñado para apoyarte a enfrentar retos diarios de tu vida, porque PL es un camino que tú vas a recorrer día a día, creando nuevas oportunidades, rompiendo con tu pasado, fortaleciendo tus relaciones y creando otra nuevas. PL es una oportunidad para crecer como ser humano. Estar en servicio de tu equipo de PL, de tu familia, la comunidad y el mundo. Tú como líder, tendrás la oportunidad de operar poderosamente en un propósito y una visión de transformación.
            </p>

            <p>
                <b>¿QUÉ BENEFICIOS TIENE PARTICIPAR EN EL PL?</b>
            </p>

            <ul>
                <li>
                    Crear resultados extraordinarios en tu vida.
                </li>
                <li>
                    Ser fuente de cambio e impacto en el mundo.
                </li>
                <li>
                    Elevar tu capacidad de liderazgo a nuevos niveles.
                </li>
                <li>
                    Rediseñar tu relación con el miedo, el riesgo y la acción comprometida.
                </li>
                <li>
                    Jugar un juego grande en la vida.
                </li>
                <li>
                    Ser auténtico- confiable- libre.
                </li>
            </ul>
            <p>
                <b>ESTRUCTURA DEL PL</b>
            </p>

            <p>
                El programa de Liderazgo esta diseñado para capacitar a personas extraordinarias a vivir sus vidas con un gran carácter, integridad, espíritu, y gozo. El programa es para un grupo selecto de participantes comprometidos a elevar quienes ellos son y su habilidad de ser creadores.
            </p>

            <p>
                Tiene una duración promedio de 60 días dividido en tres fines de semana, más una noche que se convertirá en pilar fundamental para la vida de los Lideres.
            </p>

            <p>
                NOTA: los horarios estan sujetos a cambios durante el Fin de Semana, según sea acordado con el Entrenador.
            </p>
        </div>
    }
}